<div class="flex flex-row">
  @for (avatar of avatars | slice: 0 : 4; track avatar.name; let i = $index) {
    <img
      [matTooltip]="avatar?.name"
      [src]="avatar?.imageSrc"
      class="w-6 h-6 cursor-pointer m-2px rounded-full text-card shadow-solid bg-black-200"
      [ngClass]="{ '-ml-1': i > 0 }"
      alt="{{ avatar?.name }}"
    />
  }
  @if (hasMaxNumberOfAvatars) {
    <div
      class="w-6 -ml-1 h-6 m-2px rounded-full text-card shadow-solid bg-black-200 flex flex-row items-center justify-center"
    >
      <p class="text-sm text-black-500">+{{ avatarsCountAfterTheFourth }}</p>
    </div>
  }
</div>
